import React, { useEffect, useState } from "react";
import { Alert, Spin } from "antd";
import { fetchSprZal } from "./spr-zal-api";
import SprZalGraf from "./spr-zal-graf";
import SprZalGrafGroup from "./spr-zal-graf-group";

const pick = (row, ...keys) => {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
  }
  return undefined;
};

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/**
 * Вкладка «График работы» — лист или группа по IS_GROUP.
 */
const SprZalSchedule = ({ idZal, open }) => {
  const [zal, setZal] = useState(null);
  const [isGroup, setIsGroup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || idZal == null) return;
    let cancelled = false;
    setLoading(true);
    setError("");
    fetchSprZal(idZal)
      .then((row) => {
        if (cancelled) return;
        const isGroupFlag = Number(pick(row, "isGroup", "IsGroup")) === 1;
        setIsGroup(isGroupFlag);
        setZal({
          idZal: toNumber(pick(row, "idZal", "IdZal")),
          name: pick(row, "name", "Name") ?? "",
          planStepMin: pick(row, "planStepMin", "PlanStepMin"),
          planTimeBeg: pick(row, "planTimeBeg", "PlanTimeBeg"),
          planTimeEnd: pick(row, "planTimeEnd", "PlanTimeEnd")
        });
      })
      .catch((e) => {
        if (!cancelled) setError(e.message || "Не удалось загрузить кабинет");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, idZal]);

  if (loading && !zal) {
    return (
      <div className="spr-zal-card__center">
        <Spin tip="Загрузка графика..." />
      </div>
    );
  }

  if (error) {
    return <Alert type="error" showIcon message={error} />;
  }

  if (!zal) return null;

  return (
    <div className="spr-zal-card__schedule">
      {isGroup ? <SprZalGrafGroup zal={zal} open={open} /> : <SprZalGraf zal={zal} open={open} />}
    </div>
  );
};

export default SprZalSchedule;
